module.exports = __webpack_public_path__ + "static/img/sy.e28a16eb.png";